import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { Container } from '@/components/ui/container';
import { articles } from '@/content/articles';
import { ArticleCard } from './ArticleCard';
import './blog.css';

export function RecentInsights() {
  const latest = articles
    .filter((article) => article.status === 'published')
    .slice(0, 3);
  if (!latest.length) return null;
  return (
    <section
      className="border-t border-hairline py-20 sm:py-24"
      aria-labelledby="insights-heading"
    >
      <Container>
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <p className="blog-eyebrow">FROM THE DEN BLOG</p>
            <h2
              id="insights-heading"
              className="mt-4 text-3xl font-medium tracking-tight sm:text-4xl"
            >
              A clearer view of onchain.
            </h2>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 self-start text-sm font-medium text-ink-700 transition-colors hover:text-ember-700 sm:self-auto"
          >
            Explore all articles <ArrowRight className="size-4" />
          </Link>
        </div>
        <div className="mt-10 grid gap-x-8 gap-y-12 md:grid-cols-3">
          {latest.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </Container>
    </section>
  );
}
